import { bignumber } from '../math';

export const MAX_UINT_256 = bignumber(2).pow(256).sub(1);
